import React from 'react';
import { Route } from 'react-router-dom';
import { PrivateRoute } from '../helpers/PrivateRoute';

export const renderRoutes = (routes = []) => {
    return routes.map((route, i) => {
        const Component = route.component;
        const Guard = route.isPrivate ? PrivateRoute : Route;

        return (
            <Guard
                key={route.key || i}
                path={route.path}
                exact={route.exact}
                component={Component}
            />
        );
    });
};
